/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询老师/学生基础信息接口(用于前端修改回显数据)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.CollegeStudentCertificationBaseInfoRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/college-student-certification/base-info`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
